export const goAmountTableFields = {
  MONTH: 'month',
  YEAR: 'year',
  CONSUMPTION_TYPE: 'consumptionType',
  DATA_SOURCE: 'dataSource',
  AVAILABLE_AMOUNT: 'availableAmount',
};
